import { StyleSheet } from 'aphrodite';
import { theme } from '../../styles/theme';
import { ButtonVariant } from './button';

export const buttonStyles = StyleSheet.create({
  base: {
    borderRadius: theme.size.xlarge,
    transition: 'all 0.2s ease-in-out',
  },
  contentContainerBase: {
    gap: theme.size.xxsmall,
    whiteSpace: 'nowrap',
    alignItems: 'center',
  },
  contentContainerWithoutIcon: {
    padding: `${theme.size.xxxsmall} ${theme.size.medium}`,
  },
  contentContainerWithIcon: {
    padding: `${theme.size.xxxsmall} ${theme.size.small}`,
  },
});

const buttonStylesPrimary = StyleSheet.create({
  button: {
    backgroundColor: theme.colour.purple,
    color: theme.colour.white,
  },
  hover: {
    backgroundColor: theme.colour.white,
    color: theme.colour.purple,
  },
  hoverBorder: {
    outline: `2px ${theme.colour.purple} solid`,
    outlineOffset: '-2px',
  },
  icon: {
    stroke: theme.colour.white,
  },
  iconHover: {
    stroke: theme.colour.purple,
  },
});

const buttonStylesPrimaryRed = StyleSheet.create({
  button: {
    backgroundColor: theme.colour.red,
    color: theme.colour.white,
  },
  hover: {
    backgroundColor: theme.colour.white,
    color: theme.colour.red,
  },
  hoverBorder: {
    outline: `2px ${theme.colour.red} solid`,
    outlineOffset: '-2px',
  },
  icon: {
    stroke: theme.colour.white,
  },
  iconHover: {
    stroke: theme.colour.red,
  },
});

const buttonStylesPrimaryBlue = StyleSheet.create({
  button: {
    backgroundColor: theme.colour.blue,
    color: theme.colour.white,
  },
  hover: {
    backgroundColor: theme.colour.white,
    color: theme.colour.blue,
  },
  hoverBorder: {
    outline: `2px ${theme.colour.blue} solid`,
    outlineOffset: '-2px',
  },
  icon: {
    stroke: theme.colour.white,
  },
  iconHover: {
    stroke: theme.colour.blue,
  },
});

const buttonStylesPrimaryGreen = StyleSheet.create({
  button: {
    backgroundColor: theme.colour.green,
    color: theme.colour.black,
  },
  hover: {
    backgroundColor: theme.colour.white,
    color: theme.colour.green,
  },
  hoverBorder: {
    outline: `2px ${theme.colour.green} solid`,
    outlineOffset: '-2px',
  },
  icon: {
    stroke: theme.colour.black,
  },
  iconHover: {
    stroke: theme.colour.green,
  },
});

const buttonStylesPrimaryTeal = StyleSheet.create({
  button: {
    backgroundColor: theme.colour.teal,
    color: theme.colour.white,
  },
  hover: {
    backgroundColor: theme.colour.white,
    color: theme.colour.teal,
  },
  hoverBorder: {
    outline: `2px ${theme.colour.teal} solid`,
    outlineOffset: '-2px',
  },
  icon: {
    stroke: theme.colour.white,
  },
  iconHover: {
    stroke: theme.colour.teal,
  },
});

const buttonStylesPrimaryNavy = StyleSheet.create({
  button: {
    backgroundColor: theme.colour.navy,
    color: theme.colour.white,
  },
  hover: {
    backgroundColor: theme.colour.white,
    color: theme.colour.navy,
  },
  hoverBorder: {
    outline: `2px ${theme.colour.navy} solid`,
    outlineOffset: '-2px',
  },
  icon: {
    stroke: theme.colour.white,
  },
  iconHover: {
    stroke: theme.colour.navy,
  },
});

const buttonStylesPrimaryBlack = StyleSheet.create({
  button: {
    backgroundColor: theme.colour.black,
    color: theme.colour.white,
  },
  hover: {
    backgroundColor: theme.colour.white,
    color: theme.colour.black,
  },
  hoverBorder: {
    outline: `2px ${theme.colour.black} solid`,
    outlineOffset: '-2px',
  },
  icon: {
    stroke: theme.colour.white,
  },
  iconHover: {
    stroke: theme.colour.black,
  },
});

const buttonStylesSecondary = StyleSheet.create({
  button: {
    backgroundColor: theme.colour.white,
    color: theme.colour.purple,
  },
  hover: {
    backgroundColor: theme.colour.purple,
    color: theme.colour.white,
  },
  hoverBorder: {
    outline: `2px ${theme.colour.white} solid`,
    outlineOffset: '-2px',
  },
  icon: {
    stroke: theme.colour.purple,
  },
  iconHover: {
    stroke: theme.colour.white,
  },
});

const buttonStylesSecondaryBlack = StyleSheet.create({
  button: {
    backgroundColor: theme.colour.white,
    color: theme.colour.black,
  },
  hover: {
    backgroundColor: theme.colour.purple,
    color: theme.colour.white,
  },
  hoverBorder: {
    outline: `2px ${theme.colour.white} solid`,
    outlineOffset: '-2px',
  },
  icon: {
    stroke: theme.colour.black,
  },
  iconHover: {
    stroke: theme.colour.white,
  },
});

const buttonStylesSecondaryBlue = StyleSheet.create({
  button: {
    backgroundColor: theme.colour.white,
    color: theme.colour.blue,
  },
  hover: {
    backgroundColor: theme.colour.blue,
    color: theme.colour.white,
  },
  hoverBorder: {
    outline: `2px ${theme.colour.white} solid`,
    outlineOffset: '-2px',
  },
  icon: {
    stroke: theme.colour.blue,
  },
  iconHover: {
    stroke: theme.colour.white,
  },
});

export const getButtonThemeStyles = (variant: ButtonVariant) => {
  switch (variant) {
    case 'primary-red': {
      return buttonStylesPrimaryRed;
    }
    case 'primary-blue': {
      return buttonStylesPrimaryBlue;
    }
    case 'primary-green': {
      return buttonStylesPrimaryGreen;
    }
    case 'primary-teal': {
      return buttonStylesPrimaryTeal;
    }
    case 'primary-navy': {
      return buttonStylesPrimaryNavy;
    }
    case 'primary-black': {
      return buttonStylesPrimaryBlack;
    }
    case 'secondary': {
      return buttonStylesSecondary;
    }
    case 'secondary-black': {
      return buttonStylesSecondaryBlack;
    }
    case 'secondary-blue': {
      return buttonStylesSecondaryBlue;
    }
    default: {
      return buttonStylesPrimary;
    }
  }
};
